package floris.graphics.backoffice.pages.admin.techstacks

import floris.graphics.models.domain.models.Techstack
import floris.graphics.repo.TechstackRepo
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class TechstacksViewModel(
    private val techstackRepo: TechstackRepo = TechstackRepo,
    private val coroutineScope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
) {
    private val _state = MutableStateFlow(TechstacksState())
    val state = _state.asStateFlow()

    private val _eventFlow = Channel<TechstacksUiEvent>()
    val eventFlow = _eventFlow.receiveAsFlow()

    fun onEvent(event: TechstacksEvent) = coroutineScope.launch {
        when (event) {
            is TechstacksEvent.LoadTechstacks -> {
                _state.update { it.copy(isLoading = true) }
                val items = techstackRepo.getTechstacks()
                _state.update { it.copy(techstacks = items, isLoading = false) }
            }

            is TechstacksEvent.Navigate -> _eventFlow.send(TechstacksUiEvent.Navigate(event.route))
        }
    }

    init {
        onEvent(TechstacksEvent.LoadTechstacks)
    }
}

data class TechstacksState(
    val techstacks: List<Techstack> = emptyList(),
    val isLoading: Boolean = false,
    val errorText: String = ""
)

sealed class TechstacksEvent {
    data object LoadTechstacks : TechstacksEvent()
    data class Navigate(val route: String) : TechstacksEvent()
}

sealed class TechstacksUiEvent {
    data class Navigate(val route: String) : TechstacksUiEvent()
}
